import {
  createContext,
  useContext,
  ReactNode,
  useState,
  useEffect,
} from "react";

import * as api from "shared/api/methods";

import { CALCULATOR_TYPES } from "constants/calculator";

export type ThemeData = {
  organizationId?: string;
  themeColor?: string;
  themeTextColor?: string;
  themeFont?: string;
  logoUrl?: string;
};

type WidgetOptions = {
  widgetId?: string;
  type?: typeof CALCULATOR_TYPES;
  modals?: { [key: string]: any };
  them?: ThemeData;
  [key: string]: any;
};

const WidgetOptionsContext = createContext<WidgetOptions | undefined>(
  undefined,
);

export const WidgetOptionsProvider = ({
  children,
  options = {},
}: {
  children: ReactNode;
  options?: WidgetOptions;
}) => {
  const { widgetId } = options;
  const [modals, setModals] = useState<{ [key: string]: any }>({});
  const [theme, setTheme] = useState<ThemeData>({});

  useEffect(() => {
    if (widgetId) {
      (async () => {
        const { modals, organizationId } = await api.getWidgetById(widgetId);

        setModals(modals);

        if (organizationId) {
          const organization = await api.getOrganizationById(organizationId);

          setTheme({
            organizationId: organization.id,
            themeFont: organization.themeFont,
            themeColor: organization.themeColor,
            themeTextColor: organization.themeTextColor,
            logoUrl: organization.logoUrl,
          });
        }
      })();
      return;
    }
  }, [widgetId]);

  return (
    <WidgetOptionsContext.Provider value={{ ...options, modals, theme }}>
      {children}
    </WidgetOptionsContext.Provider>
  );
};

export const useWidgetOptions = () => {
  const context = useContext(WidgetOptionsContext);

  if (context === undefined) {
    throw new Error(
      "useWidgetOptions must be used within a WidgetOptionsProvider",
    );
  }

  return context;
};
